import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'

export default function Dashboard() {
    const { t } = useTranslation()

    return (
        <Container className='p-5'>
            <Row>
                <Col>
                    <div className='sd-label-dashboard'>{t('breeder.dashboard.welcome')}</div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    <h3>{t('breeder.dashboard.subwelcome')}</h3>
                </Col>
            </Row>
            <Row>
                <Col xs={6} lg={4} className='my-3'>
                    <Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.animals")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <img src="/images/vaca.svg" width={64} height={64} alt={t('menus.animals')}/>
                                <h2 className='noBold'>{t('menus.animals')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={6} lg={4} className='my-3'>
                    <Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.events")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <img src="/images/event.svg" width={64} alt={t('menus.events')}/>
                                <h2 className='noBold'>{t('menus.events')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
}